/**
 * O que o modal de "ticket criado" precisa saber do ticket recém-criado.
 *
 * ## Por que isto saiu de dentro do componente
 *
 * Porque o defeito que esta função existe para impedir foi exatamente um erro
 * de mapeamento: o componente guardava `{ id, title, solution_due_at }` e o
 * modal lia `createdTicketInfo.number` — um campo que nunca era preenchido.
 * O resultado era um "#" sozinho na tela, com o ticket criado normalmente.
 *
 * `TicketDetails` tem mais de seis mil linhas e nenhum teste; montá-lo para
 * cobrir três atribuições não era viável. A regra, sozinha, é.
 *
 * ## `number` e `id` são coisas DIFERENTES, e as duas são necessárias
 *
 * - `number` é o número do chamado dentro da empresa — é o que as pessoas
 *   citam uma para a outra, e é o que o modal mostra. Ele é atribuído pelo
 *   servidor no momento da criação (ver `TicketNumberAllocator`), e por isso
 *   volta na resposta.
 * - `id` é a chave no banco, e é por ela que a navegação vai para o ticket
 *   (`/ticket/{id}`).
 *
 * Trocar um pelo outro não dá erro em lugar nenhum: a tela abre o ticket
 * certo e mostra o número errado, ou mostra o número certo e não abre nada.
 */

/**
 * @param {object} criado  o ticket como a API devolveu
 * @param {object} rascunho  o que estava no formulário, para os campos que a
 *   resposta pode não trazer
 * @returns {{id: *, number: *, title: string, solution_due_at: *}}
 */
export const dadosDoTicketCriado = (criado, rascunho = {}) => ({
    id: criado?.id,

    // Cai para o `id` quando o servidor não mandou número. Não acontece hoje
    // (ele é atribuído antes do insert), mas um "#" vazio é pior que um
    // número aproximado: o vazio parece que a criação falhou, e foi
    // justamente essa leitura que gerou o chamado de suporte.
    number: criado?.number ?? criado?.id,

    title: criado?.title || rascunho?.title || '',
    solution_due_at: criado?.solution_due_at ?? rascunho?.solution_due_at ?? null,
});
